<!-- 地图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 300px;
  padding: 18px 0;
}

.map {
  height: 450px;
  width: 800px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <div class="map">
    <div class="main"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
import axios from 'axios'
export default {
  data() {
    return {
      myChart: {},
      name: '赋码趋势图'
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.map .main'));
    var allData = {}
    axios.get('static/data/百色市.json').then(res => {
      // 引入地区地图
      echarts.registerMap('百色市', res.data)
      // 每个地区的坐标
      const geoCoordMap = {
        '右江区': [106.6189648699, 23.9011510432],
        '靖西市': [106.4176986464, 23.1340325224],
        '田阳县': [106.9156629745, 23.7356699750],
        '田东县': [107.1260862186, 23.5972525589],
        '平果县': [107.5898772387, 23.3293469441],
        '德保县': [106.6154958178, 23.3234056946],
        '那坡县': [105.8335036062, 23.3871180613],
        '凌云县': [106.5615967920, 24.3475183354],
        '乐业县': [106.5616359496, 24.7858389344],
        '田林县': [106.2285227061, 24.2943864015],
        '西林县': [105.0938229983, 24.4895710923],
        '隆林各族自治县': [105.3438807417, 24.7706591482]
      }

      var BJData = [
        [{ name: '' }, { name: '田阳县', value: 80 }],
        [{ name: '田阳县' }, { name: '靖西市', value: 80 }],
        [{ name: '田阳县' }, { name: '右江区', value: 80 }],
        [{ name: '田阳县' }, { name: '平果县', value: 80 }],
        [{ name: '田阳县' }, { name: '那坡县', value: 80 }],
        [{ name: '田阳县' }, { name: '乐业县', value: 80 }],
        [{ name: '田阳县' }, { name: '西林县', value: 80 }]
      ];

      var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var dataItem = data[i];
          var fromCoord = geoCoordMap[dataItem[0].name];
          var toCoord = geoCoordMap[dataItem[1].name];
          if (fromCoord && toCoord) {
            res.push({
              fromName: dataItem[0].name,
              toName: dataItem[1].name,
              coords: [fromCoord, toCoord]
            });
          }
        }
        return res;
      };

      var color = ['#06A1E7', '#2B72D6', '#ADBFFF', '#328DDF', '#6676EF', '#A5D3F0'];
      var series = [];

      function area(name, color) {
        var a = {
          name: name,
          selected: true,
          itemStyle: {
            emphasis: {
              areaColor: color,
              borderColor: '#fff',
              borderWidth: 1
            }
          }
        };
        return a;
      }

      [['百色市', BJData]].forEach(function (item, i) {
        series.push({
          type: 'lines',
          zlevel: 1,
          effect: {
            show: true,
            period: 6,
            trailLength: 0.7,
            color: '#fff', // 流向的颜色
            symbolSize: 5
          },
          lineStyle: {
            normal: {
              color: '#EF850E',
              width: 1,
              curveness: 0.2
            }
          },
          data: convertData(item[1])
        },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            rippleEffect: {
              brushType: 'stroke'
            },
            label: {
              normal: {
                show: true,
                position: 'right',
                formatter: function (val) {
                  return val.name + '\n' + val.value[2];
                },
                fontSize: 18,
                color: '#fff'
              }
            },
            symbolSize: function (val) {
              return val[2] / 8;
            },
            itemStyle: {
              normal: {
                color: color[i]
              }
            },
            data: item[1].map(function (dataItem) {
              return {
                name: dataItem[1].name,
                value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
              };
            })
          });
      });

      var option = {
        tooltip: {
          trigger: 'item'
        },
        // 地图映射颜色
        visualMap: [{
          show: false,
          inRange: {
            color: ['#ff0']
          }
          // splitNumber: 0
        }],
        grid: {
          bottom: 10,
          left: 10,
          right: '2%'
        },
        legend: {
          orient: 'vertical',
          top: 'bottom',
          left: 'right',
          textStyle: {
            color: '#fff'
          },
          selectedMode: 'single'
        },
        geo: {
          map: '百色市',
          zoom: 1.2,
          label: {
            emphasis: {
              show: false
            }
          },
          roam: false,
          itemStyle: {
            normal: {
              areaColor: '#328DDF',
              borderColor: '#BCC5EA',
              borderWidth: 2,
              shadowColor: '#5AB2FE',
              shadowBlur: 5
            }
          },
          regions: [
            area('右江区', '#328DDF'),
            area('靖西市', '#06A1E7'),
            area('田阳县', '#2B72D6'),
            area('平果县', '#ADBFFF'),
            area('那坡县', '#328DDF'),
            area('乐业县', '#6676EF'),
            area('西林县', '#A5D3F0')
          ]
        },
        series: series
      };

      this.myChart.setOption(option);

      this.init();
    })
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?79f71cc2